module.exports = __webpack_public_path__ + "img/003-cnpj.38043e0d.png";